import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Col, Icon, PreviewAltCard, Row } from "../../components/Component";
import { Button, Form } from "reactstrap";
import { useForm, useFieldArray } from "react-hook-form";

import {
  createDiseaseFaqAPI,
  listDiseaseFaqAPI,
  updateDiseaseFaqAPI,
} from "../../api/master/indes";

import { toast } from "react-toastify";
import MyButton from "../../MyComp/UI/form/MyButton";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import MyInput from "../../MyComp/UI/form/MyInput";
import useLogout from "../../hooks/useLogout";
import Table from "../../MyComp/UI/DataTable/Table";
import MySelect from "../../MyComp/UI/form/MySelect";
import CKEditor from "../../MyComp/UI/CK Editor/index";
import { diseaseDDAPI } from "../../api/dropdown";

const DiagnosisFaq = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      isPub: false,
      faqs: [{ question: "", answer: "" }],
      disease: [],
    },
  });

  const {
    fields: faqFields,
    append: addFaq,
    remove: removeFaq,
    replace
  } = useFieldArray({
    control,
    name: "faqs",
  });

  const logout = useLogout();

  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const [data, setData] = useState([]);

  const isLoading = watch("isLoading");

  // ================= INIT =================
  useEffect(() => {
    getDiseaseFaq();
    getDiseaseDD();
  }, []);

  const getDiseaseFaq = () => {
    setValue("isLoading", true);
    listDiseaseFaqAPI()
      .then((res) => {
        if (res.data.status === true) {
          setData(res.data.data || []);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setValue("isLoading", false));
  };

  const getDiseaseDD = () => {
    diseaseDDAPI()
      .then((res) => {
        if (res.data.status === true) {
          setValue("diseaseDD", res.data.data);
        } else {
          setValue("diseaseDD", []);
        }
      })
      .catch(() => { });
  };

  // ================= SUBMIT =================
  const onFormSubmit = () => {
    const disease = watch("disease") || [];

    const diseaseValue = Array.isArray(disease)
      ? disease.map((s) => s.value)
      : disease?.value || disease;
    const faqs = (watch("faqs") || []).map((faq, index) => {
      const answer =
        window?.CKEDITOR?.instances[`faq_answer_${index}`]?.getData() || "";
      return {
        question: faq.question,
        answer: answer.replace(/&nbsp;/g, " "),
      };
    });

    const body = {
      diseases_id: diseaseValue,
      faqs,
      ...(mode === "Edit" && { id: watch("selectedRow")?.id }),
    };

    const apiCall =
      mode === "Add"
        ? createDiseaseFaqAPI(body)
        : updateDiseaseFaqAPI(body);

    setValue("isLoading", true);

    apiCall
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          getDiseaseFaq();
          setIsOpen(false);
        } else if (res.data.status === "expired") {
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setValue("isLoading", false));
  };

  // ================= EDIT =================
  // const handleEdit = (row) => {
  //   console.log(row, "row");

  //   setValue("selectedRow", row);
  //   setValue("disease", row?.diseases);

  //   setValue("faqs", row?.faqs || [{ question: "", answer: "" }]);

  //   setTimeout(() => {
  //     row?.faqs?.forEach((faq, index) => {
  //       if (window?.CKEDITOR?.instances[`faq_answer_${index}`]) {
  //         window.CKEDITOR.instances[`faq_answer_${index}`].setData(
  //           faq.answer || ""
  //         );
  //       }
  //     });
  //   }, 500);

  //   setMode("Edit");
  //   setIsOpen(true);
  // };

  const handleEdit = (row) => {
    console.log(row, "row");
    setValue("selectedRow", row);
    setValue("disease", row?.diseases);

    const faqsData = row?.faqs?.length
      ? row.faqs.map((faq) => ({
        question: faq?.question || "",
        answer: faq?.answer || "",
      }))
      : [{ question: "", answer: "" }];
    replace(faqsData);

    setTimeout(() => {
      row?.faqs?.forEach((faq, index) => {
        if (window?.CKEDITOR?.instances[`faq_answer_${index}`]) {
          window.CKEDITOR.instances[`faq_answer_${index}`].setData(
            faq.answer || ""
          );
        }
      });
    }, 500);
    setMode("Edit");
    setIsOpen(true);
  };

  // ================= RESET =================
  const resetF = () => {
    setValue("disease", null);
    setValue("faqs", [{ question: "", answer: "" }]);
    setMode("Add");
  };

  const formattedData = data.map((item, index) => ({
    id: item?.id,

    // Join all disease labels into one string
    diseases_id: item?.diseases_id,
    diseases: item?.diseases_name,
    diseases_name: item.diseases_name
      ?.map((d) => d.label)
      .join(", "),
    question: item.faqs?.length
      ? item.faqs[0].question
      : "No FAQs",
    answer: item.faqs?.length
      ? item.faqs[0].answer
      : "No FAQs",
    faqs: item.faqs,
    status: item.status
  }));

  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    console.log(row, "row");

    setShowModal(true);
  };

  const confirmStatusChange = (data) => {
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    setValue("isLoading", true);
    const formObject = {
      diseases_id: watch("selectedRow")?.diseases_id,
      id: watch("selectedRow")?.id,
      status: updatedStatus,
    };
    updateDiseaseFaqAPI(formObject)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getDiseaseFaq()
          setIsOpen(false);
          setValue("isLoading", false);
          setShowModal(false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  return (
    <>
      <Head title={"Diagnosis FAQ"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              {/* <BlockTitle page tag="h3">
                {"Manage Products"}
              </BlockTitle> */}
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          {isOpen && (
            <PreviewAltCard className="mb-5" style={{ padding: "50px" }}>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="4">
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Disease"
                      name="disease"
                      options={watch("diseaseDD") || []}
                      multi
                      required
                    />
                  </Col>
                </Row>

                {/* ================= FAQ ================= */}
                <Row className="mt-4">
                  <Col md={12}>
                    <h5>FAQs</h5>
                    <Row className="mb-3">
                      {faqFields.map((item, index) => (
                        <>
                          <Col md="5">
                            <MyInput
                              key={item.id}
                              register={register}
                              name={`faqs.${index}.question`}
                              title="Question"
                              required
                              setValue={setValue}
                              trigger={trigger}
                              errors={errors}
                              placeholder={"Enter Question"}
                              defaultValue={item.question}
                            />
                            <label>Answer</label>
                            <CKEditor id={`faq_answer_${index}`} />
                          </Col>

                          <Col md="1">
                            {faqFields.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => removeFaq(index)}
                              >
                                Remove
                              </button>
                            )}
                          </Col>

                        </>

                      ))}
                    </Row>
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={() => addFaq({ question: "", answer: "" })}
                    >
                      + Add FAQ
                    </button>
                  </Col>
                </Row>

                {/* SUBMIT */}
                <Row className="mt-4">
                  <Col md="2">
                    <MyButton isLoading={isLoading} mode={mode} />
                  </Col>
                </Row>
              </Form>
            </PreviewAltCard>
          )}

          {/* TABLE */}
          <Table
            title="Diseases FAQ List"
            data={formattedData}
            columns={[
              { key: "diseases_name", label: "Disease" },
              { key: "question", label: "Question" },
              { key: "answer", label: "Answer", },
            ]}
            nameColumn="diseases_name"
            onEditClick={handleEdit}
            toggleCanvas={() => setIsOpen(!isOpen)}
            resetF={resetF}
            statusFilterEnabled={true}
            handleToggleStatus={handleToggleStatus}
            confirmStatusChange={confirmStatusChange}
            addButton={false}
          />
        </Block>
      </Content>
      <ConfirmModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setValue("isPub", false);
        }}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        isPub={watch("isPub")}
        data={watch("selectedRow")}
      />
    </>
  );
};

export default DiagnosisFaq;